const aerialApiUri = process.env.aerialPlotConnections.aerialPlotApi.baseUrl;

export function getEntityNames(flightId, fieldId, trialId, farmId, protocolId, accessToken) {
	let queryString = "";

	if (flightId) {
		queryString += `flightId=${flightId}`;
	}

	if (fieldId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `fieldId=${fieldId}`;
	}

	if (trialId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `trialId=${trialId}`;
	}

	if (farmId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `farmId=${farmId}`;
	}

	if (protocolId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `protocolId=${protocolId}`;
	}

	return fetch(`${aerialApiUri}api/v1/Entities/GetEntityNames?${queryString}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => data);
}

// For use with useQuery
export async function getEntityNamesAsync(flightId, fieldId, trialId, protocolId, accessToken) {
	let queryString = "";

	if (flightId) {
		queryString += `flightId=${flightId}`;
	}

	if (fieldId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `fieldId=${fieldId}`;
	}

	if (trialId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `trialId=${trialId}`;
	}

	if (protocolId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `protocolId=${protocolId}`;
	}

	const res = await fetch(`${aerialApiUri}api/v1/Entities/GetEntityNames?${queryString}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	});
	if (!res.ok) {
		throw new Error("failed to fetch entity names");
	}
	const data = res.json();

	return data;
}

export function checkClient(flightId, fieldId, trialId, protocolId, farmId, currentClientId, isStrict, accessToken) {
	let queryString = "";

	if (flightId) {
		queryString += `flightId=${flightId}`;
	}

	if (fieldId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `fieldId=${fieldId}`;
	}

	if (trialId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `trialId=${trialId}`;
	}

	if (protocolId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `protocolId=${protocolId}`;
	}

	if (farmId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `farmId=${farmId}`;
	}

	if (currentClientId) {
		if (queryString.length > 0) {
			queryString += "&";
		}
		queryString += `currentClientId=${currentClientId}`;
	}

	if (queryString.length > 0) {
		queryString += "&";
	}
	queryString += `isStrict=${isStrict}`;

	return fetch(`${aerialApiUri}api/v1/Entities/CheckClient?${queryString}`, {
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			if (res.status !== 204) {
				return res.json();
			} else {
				return "";
			}
		})
		.then((data) => data);
}
